<script setup>
import Multiselect from "vue-multiselect";
import {inject, onMounted, ref} from "vue";
import trackersFoldersService from "@/services/trackers-folders.service";
import {trackerTypes} from "@/constants/trackers";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const tracker = inject('tracker');
const canEditInfo = inject('canEditInfo');
const initFolderId = inject('folderId');

const foldersList = ref([]);

onMounted(() => {
    getFoldersList();
});

async function getFoldersList(folderId = 0) {
    let folderType = tracker.type === trackerTypes.PUBLIC ? trackerTypes.PUBLIC : trackerTypes.PRIVATE;

    const {data} = await trackersFoldersService.getList(folderId, folderType);
    foldersList.value = data.filter(folder => !folder.archived);

    if (foldersList.value.length) {
        foldersList.value.unshift({id: 0, name: 'None'})

        if (initFolderId) {
            tracker.folder = foldersList.value.find(item => item.id === initFolderId);
        }
    }
}
</script>

<template>
    <div v-if="foldersList.length">
        <h5 class="heading5 heading5--secondary">Folder
            <span v-if="store.getters.settings.require_folder" class="heading5__light">Required</span>
            <span v-else class="heading5__light">(Optional)</span>
        </h5>

        <Multiselect
            class="multiselect-mid"
            v-model="tracker.folder"
            :options="foldersList"
            select-label=""
            deselect-label=""
            label="name"
            track-by="name"
            :disabled="!canEditInfo"
        />
    </div>
</template>

<style scoped>

</style>
